import { Simulator } from '@/components/modules/Simulator/Simulator';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { ALL_CORE_APP_USER_TYPES, APP_ROLES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_SIMULATOR: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.SIMULATOR,
  schemesByRoles: [
    {
      roles: [APP_ROLES.MERCHANT_GROUP, APP_ROLES.MERCHANT, APP_ROLES.CHANNEL, APP_ROLES.AGENT],
      titleTextId: 'SIMULATOR',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <Simulator
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
          }}
        />
      ),
    },
  ],
};
